import SocialIcon from './SocialIcon.component';

export default SocialIcon;